/** Домены партнёров, для которых есть отдельные тексты и условия */
export const PARTNERS_DOMAINS = {
    TAKEALOT: "tibreezy.co.za",
    COMFY: "comfy.ua",
    FOXTROT: "foxtrot.com.ua",
    BREEZY_UA: "breezy.ua",
    AVO_AFRICA: "avo.africa",
    DG_CO_ZA: "dg.co.za",
    FMOBILE: "fmobile.kz",
    ISPACE_MD: "ispace.md",
    ORANGE_MD: "orange.md",
} as const;

export type PartnerDomain = (typeof PARTNERS_DOMAINS)[keyof typeof PARTNERS_DOMAINS];
